import EntityType from 'txp-data/lib/schema/innerSchema/EntityType';
import { SERVICE_RESERVATION_FEATURE } from '../../helpers/FeatureFlagName';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isEntityTypeEditable(entityType: EntityType): boolean {
    return (
        entityType === EntityType.LodgingReservation ||
        (entityType === EntityType.ServiceReservation &&
            isFeatureEnabled(SERVICE_RESERVATION_FEATURE))
    );
}
